// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "Wymagany jest link do Twojej reklamy Airbnb",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "Ocena Airbnb musi wynosić co najmniej 4 do 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Załóż konto, sprawdź swoją skrzynkę e-mail, aby aktywować dostęp do klubu",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Klub zarezerwowany dla gości airbnb, a nie s'4 5",
  comparez_vos_gains_r_els: "Porównaj swoje rzeczywiste zarobki",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "Mod traveltrok jest zwycięzcą, podróżnik wygrywa",
  votre_prix_sur_les_autres_sites: "Twoja cena na innych stronach",
  diminuer_le_prix: "Obniż cenę",
  augmenter_le_prix: "Zwiększ cenę",
  net_pour_vous: "Netto dla Ciebie",
  de_commissions: "Prowizje",
  prix_pay__par_le_voyageur: "Cena płacona przez podróżnego",
  revenu___d_clarer__imp_ts_: "Dochód do zadeklarowania podatków",
  vous_d_clarez_100__du_prix____commissions__:
    "Deklarujesz 100 prowizji cenowych",
  de_frais_h_te: "Opłaty gospodarza",
  __0__compar____booking_: "0 rezerwacji porównawczych",
  mod_le_frais_h_te__depuis_25_____: "Modyfikacja opłaty hosta od 25",
  vous_d_clarez_100__du_prix_voyageur_: "Deklarujesz 100 ceny pasażera",
  strat_gie_gagnante: "Zwycięska strategia",
  prix_voyageur: "Cena podróżnika",
  _5__pour_le_voyageur: "5 dla podróżnika",
  le_meilleur_des_deux_mondes: "To, co najlepsze z obu światów",
  avantage_fiscal: "Korzyść podatkowa",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Deklarujesz mniej, płacisz mniejsze podatki",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok pobiera 5 opłat podróżnych",
  appartement: "Apartament",
  maison: "Dom",
  inclut_villa_chalet: "Obejmuje willę w domku",
  loft: "Strych",
  luxe: "Luksus",
  insolite: "Niezwykłe",
  autre: "Inny",
  campagne: "Kampania",
  mer: "Morze",
  montagne: "Góra",
  au_dessus_de_500_nuit: "Powyżej 500 €/noc",
  aucun_resultat_dynamique: "Brak wyników dynamicznych",
  service_de_localisation_indisponible__r_essayez_da:
    "Usługa lokalizacyjna niedostępna. Spróbuj ponownie za chwilę",
  quel_type_de_logement_souhaitez_vou:
    "Jaki rodzaj zakwaterowania chcesz zaoferować?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Wybierz kategorię, która najlepiej opisuje Twoje zakwaterowanie",
  quel_est_le_cadre_du_logement__: "Jakie jest środowisko mieszkaniowe?",
  o__est_situ__votre_logement__: "Gdzie znajduje się Twoje zakwaterowanie?",
  pays_europ_en_de_r_f_rence: "Europejski kraj odniesienia",
  ville__village__code_postal___: "Miasto, wieś, kod pocztowy...",
  recherche_en_cours___: "Badania w toku...",
  recherche___: "Badania...",
  localiser: "Lokalizować",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Wykorzystamy ten adres do zlokalizowania Twojego zakwaterowania",
  localis_: "Zlokalizowane",
  _copy__openstreetmap_france: "© OpenStreetMap Francja",
  emplacement_valid_: "Sprawdzona lokalizacja",
  d_crivez_votre_logement: "Opisz swoje zakwaterowanie",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Spraw, aby podróżni chcieli zatrzymać się u Ciebie",
  titre_de_l__annonce: "Tytuł reklamy",
  ex__charmant_studio_au_c_ur_de_paris:
    "Przykład: Urocze studio w sercu Paryża",
  soyez_concis_et_accrocheur: "Bądź zwięzły i chwytliwy",
  description_d_taill_e: "Szczegółowy opis",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Porozmawiaj o swoim zakwaterowaniu, okolicy, udogodnieniach...",
  mentionnez_les_points_forts: "Wspomnij o mocnych stronach",
  voyageurs: "Podróżnicy",
  chambres: "Pokoje",
  lits: "Łóżka",
  salles_de_bain: "Łazienki",
  d_tails_du_logement: "Szczegóły zakwaterowania",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Podaj więcej informacji na temat możliwości odbioru",
  surface__m__: "Powierzchnia (m²)",
  ex__85: "Np.: 85",
  ajoutez_des_photos: "Dodaj zdjęcia",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Wyróżnij swój dom pięknymi obrazami",
  glissez_vos_photos_ici: "Przeciągnij tutaj swoje zdjęcia",
  parcourez_vos_fichiers: "Przeglądaj swoje pliki",
  jpg__png_jusqu____5_mo: "JPG, PNG (do 5 MB)",
  d_j__en_ligne: "Już w Internecie",
  __uploader: "Aby przesłać",
  fixez_votre_prix: "Ustal swoją cenę",
  vous_pourrez_le_modifier___tout_moment_:
    "Możesz go modyfikować w dowolnym momencie",
  par_nuit: "Za noc",
  aper_u_de_votre_annonce: "Podgląd reklamy",
  titre_de_votre_annonce: "Tytuł Twojej reklamy",
  nouveau: "Nowy",
  localisation: "Lokalizacja",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Usuwanie profilu typu usuń, a następnie potwierdź, jeśli całkowite usunięcie nie jest możliwe, Twój profil zostanie wstrzymany i ukryty",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Całkowicie usuń niedostępny profil wstrzymany i ukryj",
  preferences: "Preferencje",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Zarządzaj swoimi jednostkami, widocznością i statusem swojego profilu",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Pozostaniesz połączony, ale Twoje reklamy nie będą już aktywne w sugestiach",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Twój profil i Twoje zakwaterowanie nie będą już wyświetlane na mapach ani na stronach miejsc docelowych",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Baza danych nie została przeniesiona. Twoje preferencje są na razie zapisywane lokalnie",
  delai_depasse: "Termin przekracza",
  echeance_aujourd__hui: "Termin na dzisiaj",
  mois_restants: "Pozostałe miesiące",
  nuits_dues_et_aucun_accueil_effectue: "Terminy i brak odbioru",
  suivi_des_echanges: "Monitorowanie wymian",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Śledź noclegi należne w obie strony, kto jest Ci winien noclegi, komu jesteś winien oraz czas pozostały do ​​zamknięcia każdej wymiany",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Podaj daty umowy zakwaterowania, status obu stron i pozostały czas",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Wizualizuj miasta docelowe i przeszukuj promienie wokół każdego punktu",
  __d_couvrir___: "zakryć",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "Najważniejsze miejsca, które warto odwiedzić podczas pobytu",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Nie można sfinalizować żądania. Spróbuj ponownie",
  r_server_ton_s_jour___: "zarezerwuj pobyt",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Proste, 3-etapowe wyszukiwanie szczegółów v",
  recherche: "Badania",
  validation: "Walidacja",
  demande_envoy_e: "Zapytanie wysłane",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Gospodarz szybko odpowie i poda szczegóły",
  cr_er_une_nouvelle_demande: "utwórz nowe żądanie",
  "1__ton_s_jour": "1 dzień",
  arriv_e: "Przyjazd",
  pers_: "Ludzie",
  dates_flexibles: "Elastyczne terminy",
  dates_exactes: "Dokładne daty",
  _3_jours: "3 dni",
  _7_jours: "7 dni",
  _14_jours: "14 dni",
  je_voyage_avec_des_animaux: "Podróżuję ze zwierzętami",
  "2__infos_r_servation": "2 informacje o rezerwacji",
  nom_complet: "Pełne imię i nazwisko",
  ex__clara_martin: "była Clara Martin",
  message___l_h_te: "Wyślij wiadomość do gospodarza",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "Wymagany jest szybki czas przybycia prezentacji",
  "3__validation_de_la_r_servation": "3 potwierdzenie rezerwacji",
  destination: "Miejsce docelowe",
  s_jour: "zostawać",
  flexibilit_: "Elastyczność",
  tarification_traveltrok: "Ceny Traveltroka",
  frais_plateforme: "Opłaty za platformę",
  "1eur_voyageur___1eur_h_te": "1ich podróżnik 1ich gospodarz",
  incluse: "Dołączony",
  total_estim_: "Całkowity szacunek",
  continuer: "Kontynuować",
  envoi___: "Przesyłka",
  confirmer_ma_r_servation: "Potwierdź moją rezerwację",
  r_sum__intelligent: "Suma R mądra",
  prix_base: "Cena bazowa",
  total_actuel: "Aktualna suma",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "W cenę wliczony jest 1 gość i 1 gość na noc",
  membres_actifs: "Aktyw",
  note_moyenne: "Średnia ocena",
  d_couvrez_: "odkryć",
  points_forts: "Przegląd najważniejszych wydarzeń",
  conseils_pratiques: "Praktyczne porady",
  informations_pratiques: "Informacje praktyczne",
  meilleure_saison: "Najlepszy sezon",
  s_jour_moyen: "średni pobyt",
  langue: "Język",
  monnaie: "Gotówka",
  fuseau_horaire: "Strefa czasowa",
  voir_les_logements: "Zobacz noclegi",
  nous_contacter: "Skontaktuj się z nami",
  villa: "Willa",
  logements_disponibles___: "Dostępne zakwaterowanie",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Oferty noclegowe ze zweryfikowanymi gospodarzami",
  voir_la_carte_des_logements: "Zobacz mapę zakwaterowania",
  h_te_v_rifi_: "zweryfikowany gospodarz",
  mod_le_traveltrok: "Zmodyfikuj traveltroka",
  r_server: "zarezerwować",
  pas_encore_de_logements_ici: "Nie ma tu jeszcze noclegu",
  sois_le_premier_h_te___proposer_son_logement___:
    "Bądź pierwszym gospodarzem, który zaoferuje zakwaterowanie",
  ajouter_mon_logement: "Dodaj moje zakwaterowanie",
  destinations_proches: "Pobliskie miejsca docelowe",
  explorez_d_autres_destinations_en_: "Odkryj inne miejsca w",
  am_rique_du_nord: "Ameryka Północna",
  am_rique_du_sud: "Ameryka Południowa",
  oc_anie: "Oceania",
  afrique: "Afryka",
  asie: "Azja",
  europe: "Europa",
  carte_des_destinations: "Mapa docelowa",
  destinations_affich_es: "Wyświetlane cele",
  continents: "Kontynenty",
  survolez_un_point_pour_voir_les_d_tails:
    "Najedź kursorem na punkt, aby zobaczyć szczegóły",
  _changes_r_alis_s: "wprowadzone zmiany",
  mes_favoris: "Moje ulubione",
  sauvegard_: "Kopia zapasowa",
  tout_effacer: "Wyczyść wszystko",
  s_lectionn_: "Wybór",
  pour_comparaison: "Dla porównania",
  voir_la_comparaison: "Zobacz porównanie",
  trier_par__: "sortować według",
  note: "Notatka",
  _changes: "zmiany",
  capacit_: "Pojemność",
  pi_ces: "Sztuki",
  type_de_logement: "Rodzaj zakwaterowania",
  effacer: "Aby wymazać",
  r_initialiser_les_filtres: "R inicjalizuj filtry",
  filtres_actifs__: "Aktywne filtry",
  aucun_r_sultat: "Brak wyników",
  aucun_favori_ne_correspond___vos_filtres_:
    "Żadne ulubione nie pasują do wybranych filtrów",
  comparaison_des_logements: "Porównanie zakwaterowania",
  logements_s_lectionn_s: "Wybrane noclegi",
  fermer: "Zamknąć",
  astuce: "Sztuczka",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Użyj filtrów, aby zawęzić ulubione",
  type: "Uprzejmy",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Następnie wybierz maksymalnie 4 miejsca dla",
  aucun_sch_ma_conversation_compatible_trouv__:
    "Nie znaleziono sch mojej kompatybilnej rozmowy",
  souhaite_venir_dynamique: "Chcę przyjść dynamicznie",
  aimerais_visiter_dynamique: "Chciałbym odwiedzić dynamic",
  demande_ignor_e_: "Prośba zignorowana",
  conversation_introuvable_: "Nie znaleziono rozmowy",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "W tej chwili nie można otworzyć dyskusji",
  demande_supprim_e_: "Żądanie usunięte",
  bonjour_merci_dynamique: "Witam, dziękuję dynamicznie",
  demande_supprim_e_avec_un_message_poli_:
    "Prośba została usunięta wraz z grzeczną wiadomością",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "W tej chwili nie można usunąć tego żądania",
  demandes_directes: "Bezpośrednie prośby",
  matching_auto: "Chcą przyjechać do Twojej okolicy",
  match_r_ciproque: "Wzajemne dopasowanie",
  carte_secteur: "Karta sektora",
  toutes: "Wszystko",
  lik_es: "Podobało się",
  en_discussion: "W trakcie dyskusji",
  ignor_es: "Ignorowane",
  sans_date_pr_cise__juste__change_: "Bez konkretnej daty po prostu wymiana",
  date_pr_cise___dans_les_6_mois: "Konkretna data w ciągu 6 miesięcy",
  date_pr_cise___dans_l_ann_e: "Konkretny dzień w roku",
  flexible: "Elastyczny",
  date_pr_cise: "Konkretna data",
  dates_identiques: "Te same daty",
  dates_compatibles: "Zgodne daty",
  dates_diff_rentes: "Różne daty",
  dates_inconnues: "Daty nieznane",
  souhaite_venir__: "Chcę przyjechać",
  voir_le_logement_cibl_: "Zobacz docelowe zakwaterowanie",
  personnes_int_ress_es_par_votre_secteur: "Osoby zainteresowane Twoją branżą",
  vert___match_r_ciproque_ville___dates:
    "Zielone daty wzajemnego dopasowania miast",
  int_r_t_entrant: "Przychodzące zainteresowanie",
  logement_cibl___: "Ukierunkowane mieszkanie",
  dates__: "Daty",
  sans_date_pr_cise: "Bez konkretnej daty",
  ouvrir_le_chat: "Otwórz czat",
  pas_encore_de_points_sur_la_carte: "Nie ma jeszcze punktów na mapie",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Członkowie, którzy chcą przyjechać do Twojej okolicy, aby",
  logement_vis_: "Ukierunkowane zakwaterowanie",
  demande: "Wniosek",
  message: "Wiadomość",
  logement_s_: "zakwaterowanie(a)",
  annonce_indisponible: "Ogłoszenie niedostępne",
  jour_s_: "dni)",
  dur_e___d_finir: "Czas do zakończenia",
  match_auto: "Automatyczne dopasowanie",
  r_ciproque: "Odwrotność",
  discuter_dans_la_messagerie: "Czatuj w wiadomościach",
  ignorer_la_demande: "Zignoruj ​​prośbę",
  ignorer: "Ignorować",
  supprimer_avec_message_poli: "Usuń z grzeczną wiadomością",
  poli: "Grzeczny",
  supprimer_sans_message: "Usuń bez wiadomości",
  suppr_: "Usuwać",
  aucune_demande_pour_le_moment: "W tej chwili nie ma żadnych żądań",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "Tablica jest już gotowa i tutaj będą się pojawiać prośby",
  surface: "Powierzchnia",
  voyagez: "Podróż",
  envie_d___changer_avec_: "Chcesz zmienić z",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Zaproponuj wymianę mieszkania i pokrycie",
  gratuitement_: "Bezpłatny",
  voir_la_fiche_du_logement: "Zobacz kartę zakwaterowania",
  carte_des_logements: "Mapa mieszkaniowa",
  r_sultats_visibles: "widoczne rezultaty",
  jour: "Dzień",
  s_lectionn_s: "wybrane s",
  printemps: "Wiosna",
  _t_: "T",
  automne: "Jesień",
  hiver: "Zima",
  toute_l__ann_e: "Przez cały rok",
  bonjour_host_dynamic: "Witam gospodarza dynamicznego",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Nie można skontaktować się z tym komunikatem o błędzie hosta",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "W tej chwili nie można skontaktować się z tym gospodarzem",
  annonce_introuvable_: "Nie znaleziono ogłoszenia",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Wybierz daty wysłania propozycji",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "Data wyjazdu musi być późniejsza niż data przyjazdu",
  proposition_d__change_avec_dates_pr_cises:
    "Propozycja wymiany z konkretnymi datami",
  __logement_cibl_: "Docelowe mieszkanie",
  __ville: "Miasto",
  __arriv_e_souhait_e: "Pożądany przyjazd",
  __d_part_souhait_: "Pożądany wyjazd",
  __dur_e: "Czas trwania",
  nuit_s_: "Noc (e)",
  __voyageurs: "Podróżnicy",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "W razie potrzeby jestem otwarty na negocjacje.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Wskaż prawidłową liczbę noclegów dla propozycji",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Elastyczna propozycja wymiany bez ustalonych terminów",
  __je_propose: "proponuję",
  __je_demande: "pytam",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Następnie wspólnie sprawdzamy daty, zgodnie z naszą dostępnością.",
  indiquez_un_nombre_de_nuits_valide_: "Wprowadź prawidłową liczbę nocy",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Propozycja wymiany o każdej porze roku",
  __dur_e_souhait_e: "Pożądany czas trwania",
  __p_riode_pr_f_r_e: "Preferowany okres",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Jestem elastyczny co do dokładnych terminów i chętnie o tym porozmawiam.",
  proposition_invalide_: "Nieprawidłowa propozycja",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Propozycja wysłana, dyskusja otwarta...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Nie można wysłać propozycji",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "W tej chwili nie można wysłać Twojej propozycji",
  logement_introuvable: "Nie znaleziono zakwaterowania",
  retour_aux_logements: "Powrót do zakwaterowania",
  annonce_airbnb: "Reklama Airbnb",
  lien_airbnb_verification_helper:
    "Dzięki temu linkowi możemy zweryfikować, czy jesteś menedżerem ogłoszenia.",
  aucune_photo_disponible: "Brak dostępnych zdjęć",
  logement_propos__par: "Zakwaterowanie oferowane przez",
  __propos_de_ce_logement: "O tym zakwaterowaniu",
  aucune_description_fournie_: "Brak opisu",
  ce_que_propose_ce_logement: "Co oferuje to zakwaterowanie",
  description_du_logement: "Opis zakwaterowania",
  aucun__quipement_sp_cifi__: "Brak określonego sprzętu",
  _change_entre_h_tes: "wymiana między gospodarzami",
  votre_proposition_d__change: "Twoja propozycja wymiany",
  quand_vous_voulez: "Kiedy chcesz",
  je_propose: "proponuję",
  nuits_chez_moi: "Noce u mnie",
  je_demande: "pytam",
  nuits_chez_vous: "Noce u Ciebie",
  nombre_de_nuits: "Liczba nocy",
  p_riode_pr_f_r_e: "Preferowany okres",
  message__optionnel_: "Opcjonalna wiadomość",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex jesteśmy elastyczni, możemy dostosować się do Twoich",
  entrer_en_n_gociation: "Wejdź w negocjacje",
  envoyer_ma_proposition: "Wyślij moją propozycję",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Możesz zaoferować wymianę z datami lub bez",
  informations_l_gales: "Informacje prawne",
  conditions_d____utilisation: "Warunki użytkowania",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Korzystając z traveltrok wyrażasz zgodę na jego użycie",
  les__changes_se_font_directement_entre_membres__:
    "Wymiany dokonywane są bezpośrednio pomiędzy członkami",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL może zawiesić konto w przypadku współpracy",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Dołączając do DONKEY TRAVEL akceptujesz te zobowiązania. Zaufanie buduje się na prostych działaniach.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Solidny statut zgodny z najlepszymi praktykami innych znanych firm.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Wystąpienie z klubu w wyniku powtarzającego się lub poważnego niewłaściwego zachowania.",
  exclusion_d_finitive: "Trwałe wykluczenie",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Konto z ograniczeniami oczekujące na fakty.",
  suspension_temporaire: "Tymczasowe zawieszenie",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Przypomnienie zasad i wymagana korekta.",
  avertissement_officiel: "Oficjalne ostrzeżenie",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "Klub chroni godnych zaufania gości. Poważne naruszenia skutkują podjęciem działań.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Każde anulowanie musi zostać udokumentowane w wiadomościach i przetworzone przez dział wsparcia.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "Nie anulujemy wymiany bez ważnego powodu. W przypadku działania siły wyższej (katastrofa, poważna choroba, niemożność prawna) należy jak najszybciej zaproponować przełożenie terminu.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "W razie wątpliwości lub zmian szybko się komunikuję.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Witam kogoś, kto wykonuje tę samą pracę jako gospodarz.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Zapewniam ciepłe i profesjonalne powitanie.",
  relation_entre_h_tes: "Relacje między gospodarzami",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Wszelkie opłaty za sprzątanie są ogłaszane i zatwierdzane przed wymianą.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "Informacje dotyczące dostępu i obsługi są jasne.",
  linge_et_pr_paration: "Pranie i przygotowanie",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "Poziom obsługi pozostaje taki sam, nawet w przypadku bezpłatnej wymiany.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "Mieszkanie jest czyste i gotowe do zamieszkania po przyjeździe.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Przygotowuję nocleg jak dla klienta Airbnb.",
  qualit__d_accueil__quivalente: "Równoważna jakość odbioru",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Szanuję spokój, sąsiadów i okolicę.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "W obiekcie zakwaterowania nie są dozwolone żadne imprezy, wydarzenia ani nieautoryzowane zaproszenia.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Przestrzegam regulaminu wewnętrznego gospodarza.",
  vie_de_quartier_et_r_gles: "Życie i zasady sąsiedztwa",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Gdy terminy są zablokowane, zobowiązuję się do przyjścia.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Nie kłamię na temat zwykłej ceny mojego zakwaterowania.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Nie kłamię na temat mojego profilu, mojej historii ani mojego zakwaterowania.",
  honn_tet__et_fiabilit_: "Uczciwość i rzetelność",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Szanuję materiały, sprzęt i instrukcje wyjazdu.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Zużytą pościel (np. prześcieradła w kłębek) przechowuję we wskazanym miejscu, aby ograniczyć koszty sprzątania.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Zapewniam zakwaterowanie tak czyste, jak je zastałem.",
  respect_total_du_logement: "Całkowity szacunek dla mieszkań",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL jest poważnym klubem-gospodarzem; dobra ocena oznacza wzorowe zachowanie, zarówno jako podróżny, jak i gospodarz.",
  "howItWorks.cta.explore": "Przeglądaj miejsca docelowe",
  "howItWorks.cta.signup": "Zobacz nasze oferty",
  "howItWorks.cta.subtitle":
    "Zacznij od wynajęcia własnego lokalu. Następnie aktywuj wymiana, jeśli chcesz wymieniać się między hostami.",
  "howItWorks.cta.title": "Gotowy do uruchomienia wypożyczalni?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Opublikuj swoje zakwaterowanie, zatwierdź swój profil i zacznij otrzymywać oferty wymiany.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Zobacz gęstość zabudowy już zarejestrowanej w klubie. Punkty pozostają anonimowe (bez adresu, bez szczegółów, tylko dynamika sieci).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Cofnij się o krok, aby uniknąć wypalenia zawodowego spowodowanego ciągłym hostingiem.",
  _an: "/ rok",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL łączy gości na całym świecie w celu zapewnienia autentycznych i niedrogich pobytów.",
  ____100__made_in_france__picardie_:
    "🇫🇷 100% wyprodukowane we Francji (Pikardia)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Nie Dolina Krzemowa, ale Dolina Haute-Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Wymiany w całej Europie pomiędzy gospodarzami Airbnb uzyskały ocenę 4,5+. Oferta premiery na rok 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Po miesiącach hostingu zamień swoje wolne okresy w prawdziwą chwilę wytchnienia, nie nadwyrężając budżetu.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Cofnij się o krok, aby uniknąć wypalenia zawodowego spowodowanego ciągłym hostingiem.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Powitaj gości, którzy już znają wymagania danej dziedziny, a następnie podziel się swoimi metodami i opiniami.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Podróżuj taniej dzięki wymianom pomiędzy członkami klubu.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Po osiągnięciu limitu lokalnego możesz handlować poza platformą, z zastrzeżeniem lokalnych przepisów.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL to europejska rewolucja: platforma wymiany dla gości, którzy już płacą za ogrzewanie, podatki, prąd, internet i konserwację i witają przez cały rok jak w hotelu. Tutaj wchodzisz w interakcję z gospodarzami, którzy wiedzą, jak Cię powitać, dzielisz się swoimi doświadczeniami, a następnie udajesz się i odkrywasz inne miejsce bez rozbijania banku.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉Nasz model opiera się wyłącznie na abonamentach, a nie na wykorzystaniu danych.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Bez reklam. Bez odsprzedaży danych. W 100% finansowane przez członków.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "Klub nie jest poradą prawną; każdy członek musi przestrzegać lokalnych przepisów (deklaracje, kwoty, współwłasność, opodatkowanie itp.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Europejska platforma wymiany zarezerwowana dla gospodarzy Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Prywatny klub dla gości z oceną 4,5+: wyjątkowa subskrypcja umożliwiająca wymianę w całej Europie.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Zarezerwowane dla gospodarzy Airbnb z oceną większą lub równą 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "50% obniżka w 2026 r.: 25 EUR/rok zamiast 50 EUR/rok. Cena gwarantowana dożywotnio dla pierwszych 1000 rejestracji.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Poza sezonem, przerwy, spotkania gości, wakacyjne oszczędności: wszystko jest przeznaczone dla aktywnych gości w Europie.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Witamy członków i zapraszamy ponownie. Prosta, bezpośrednia i bezgotówkowa wymiana między właścicielami.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'\"Zamieniliśmy nasz dom w Lyonie na willę na Korsyce. Koszt: 0 €.\"'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Żadnych monet, żadnych punktów. To tylko umowa pomiędzy dwoma właścicielami. Przychodzę do twojego domu, ty przychodzisz do mojego domu.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Znajdujesz członka, który Ci się podoba i zgadzasz się na wymianę zakwaterowania.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Nie ma punktów do zliczenia. Sama przyjemność dzielenia się i spotykania.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "To więcej niż ekonomia, to nowy sposób podróżowania.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Wymiany są całkowicie bezpłatne. Żadnych opłat za usługi, żadnych opłat za sprzątanie (chyba że zostało to wyraźnie uzgodnione).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Tylko zweryfikowani gospodarze mogą handlować. Przyjmujesz kogoś, kto zna wartość domu.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Zapomnij o wartości punktów. Noc jest nocą. Wymiana opiera się na zaufaniu pomiędzy gospodarzami.",
  __an: "/ rok",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Wymiany w całej Europie pomiędzy gospodarzami Airbnb uzyskały ocenę 4,5+. Oferta premiery na rok 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Po miesiącach hostingu zamień swoje wolne okresy w prawdziwą chwilę wytchnienia, nie nadwyrężając budżetu.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Cofnij się o krok, aby uniknąć wypalenia zawodowego spowodowanego ciągłym hostingiem.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Powitaj gości, którzy już znają wymagania danej dziedziny, a następnie podziel się swoimi metodami i opiniami.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Podróżuj taniej dzięki wymianom pomiędzy członkami klubu.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Po osiągnięciu limitu lokalnego możesz handlować poza platformą, z zastrzeżeniem lokalnych przepisów.",
  la_r_volution_des_h_tes_en_europe: "Rewolucja gospodarza w Europie",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Wreszcie przerwa dla gospodarzy Airbnb ocenionych na 4,5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL to europejska rewolucja: platforma wymiany dla gości, którzy już płacą za ogrzewanie, podatki, prąd, internet i konserwację i witają przez cały rok jak w hotelu. Tutaj wchodzisz w interakcję z gospodarzami, którzy wiedzą, jak Cię powitać, dzielisz się swoimi doświadczeniami, a następnie udajesz się i odkrywasz inne miejsce bez rozbijania banku.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Cena gwarantowana dożywotnio dla pierwszych 1000 rejestracji.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "W DONKEY TRAVEL Twoje dane nie są produktem.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Nigdy nie sprzedajemy informacji o naszych członkach.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Nie udostępniamy żadnych danych podmiotom trzecim w celach komercyjnych.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "Strona jest bezpieczna, a Twoje wymiany pozostają prywatne.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL gwarantuje brak reklam: jesteś członkiem, a nie produktem.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉Nasz model opiera się wyłącznie na abonamentach, a nie na wykorzystaniu danych.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Bez reklam. Bez odsprzedaży danych. W 100% finansowane przez członków.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "Klub nie jest poradą prawną; każdy członek musi przestrzegać lokalnych przepisów (deklaracje, kwoty, współwłasność, opodatkowanie itp.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Europejska platforma wymiany zarezerwowana dla gospodarzy Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Prywatny klub dla gości z oceną 4,5+: wyjątkowa subskrypcja umożliwiająca wymianę w całej Europie.",
  acc_s_r_serv_: "Zarezerwowany dostęp",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Zarezerwowane dla gospodarzy Airbnb z oceną większą lub równą 4,5.",
  europe_unique: "Pojedyncza Europa",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/rok do wymiany w całej Europie.",
  lancement_2026: "Uruchomienie 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "50% obniżka w 2026 r.: 25 EUR/rok zamiast 50 EUR/rok. Cena gwarantowana dożywotnio dla pierwszych 1000 rejestracji.",
  club_d__change_h_tes_airbnb: "Klub wymiany gospodarzy Airbnb",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Zoptymalizuj okresy poza szczytem dzięki giełdom",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Poza sezonem, przerwy, spotkania gości, wakacyjne oszczędności: wszystko jest przeznaczone dla aktywnych gości w Europie.",
  r_serv__aux_h_tes_traveltrok: "Zarezerwowane dla gości DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Podróżuj bezpłatnie z zakwaterowaniem",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Witamy członków i zapraszamy ponownie. Prosta, bezpośrednia i bezgotówkowa wymiana między właścicielami.",
  devenir_h_te: "Zostań gospodarzem",
  comment__a_marche__: "Jak to działa?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'\"Zamieniliśmy nasz dom w Lyonie na willę na Korsyce. Koszt: 0 €.\"'",
  amis_partageant_un_repas_en_corse: "Przyjaciele jedzący posiłek na Korsyce",
  sophie___marc__membres_depuis_2023: "Sophie i Marc, członkowie od 2023 r",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Nie ma potrzeby wymieniać się w tych samych terminach: Ty przyjeżdżasz do mnie w czerwcu, ja do Twojego domu we wrześniu!",
  l__change_direct___simple_et_humain: "Wymiana bezpośrednia: prosta i ludzka",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Żadnych monet, żadnych punktów. To tylko umowa pomiędzy dwoma właścicielami. Przychodzę do twojego domu, ty przychodzisz do mojego domu.",
  "1__accord_mutuel": "1. Obustronne porozumienie",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Znajdujesz członka, który Ci się podoba i zgadzasz się na wymianę zakwaterowania.",
  "2__flexibilit__totale": "2. Całkowita elastyczność",
  "3__z_ro_comptabilit_": "3. Zerowa księgowość",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Nie ma punktów do zliczenia. Sama przyjemność dzielenia się i spotykania.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Dlaczego gospodarze uwielbiają ten system?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "To więcej niż ekonomia, to nowy sposób podróżowania.",
  "0__de_frais": "0€ opłat",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Wymiany są całkowicie bezpłatne. Żadnych opłat za usługi, żadnych opłat za sprzątanie (chyba że zostało to wyraźnie uzgodnione).",
  confiance_totale: "Całkowita pewność",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Tylko zweryfikowani gospodarze mogą handlować. Przyjmujesz kogoś, kto zna wartość domu.",
  simplicit_: "Prostota",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Zapomnij o wartości punktów. Noc jest nocą. Wymiana opiera się na zaufaniu pomiędzy gospodarzami.",
  rejoignez_la_communaut__des_h_tes: "Dołącz do społeczności gospodarzy",
  rejoignez_la_communaut__et_commencez____changer_:
    "Dołącz do społeczności i zacznij rozmawiać.",
  commencer_maintenant: "Zacznij teraz",
  chargement___: "Załadunek...",
  accueil: "Powitanie",
  comment_a_marche: "Jak to działa",
  vos_engagements: "Twoje zobowiązania",
  pays: "Kraj",
  logements: "Mieszkania",
  _change_h_te: "Wymiana hostów",
  devenir_membre: "Zostań członkiem",
  se_d_connecter: "Wyloguj się",
  mon_espace: "Moja przestrzeń",
  connexion: "Połączenie",
  connect_: "Połączony",
  visuel_en_cours_de_g_n_ration_ai___:
    "Generowana wizualna sztuczna inteligencja...",
  tableau_de_bord: "Panel",
  mes_annonces: "Moje reklamy",
  o__je_veux_aller: "Gdzie chcę iść",
  qui_veut_venir_chez_moi: "Inteligentne dopasowanie",
  destinations: "Miejsca docelowe",
  carte_des_membres: "Karta członkowska",
  calendrier: "Kalendarz",
  votre_coffre: "Twój sejf",
  favoris: "Ulubione",
  messages: "Wiadomości",
  mon_profil: "Mój profil",
  pr_f_rences: "Preferencje",
  profil: "Profil",
  h_te: "Gospodarz",
  membre_fondateur: "Członek założyciel",
  membre: "Członek",
  r_duire__tendre: "Zmniejsz/rozszerz",
  r_duire_le_menu: "Zwiń menu",
  cette_page_n_a_pas__t__g_n_r_e: "Ta strona nie została wygenerowana",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Podaj więcej szczegółów na temat tej strony, abym mógł ją wygenerować",
  connexion_en_cours___: "Trwa połączenie...",
  email_ou_mot_de_passe_incorrect: "Nieprawidłowy adres e-mail lub hasło",
  une_erreur_est_survenue: "Wystąpił błąd",
  erreur_de_connexion_google: "Błąd połączenia Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Zaloguj się, aby znaleźć swoją społeczność",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Dołącz do społeczności gospodarzy DONKEY TRAVEL",
  inscription: "Rejestracja",
  continuer_avec_google: "Kontynuuj z Google",
  ou: "Lub",
  ton_pr_nom_et_nom: "Twoje imię i nazwisko",
  jean_h_mar: "Jana Hemara",
  lien_annonce_airbnb: "Link do Twojej oferty Airbnb",
  veuillez_saisir_un_lien_airbnb_valide: "Podaj prawidłowy link do Airbnb",
  lien_calendrier_ical:
    "Link iCal do Twojego kalendarza Airbnb (na razie opcjonalne)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel nigdy nie zmienia Twojego kalendarza Airbnb. Przeczytaliśmy go tylko, aby pokazać Twoją dostępność. Aby uniknąć podwójnych rezerwacji, będziesz musiał nadal ręcznie blokować daty realizacji na Airbnb.",
  note_airbnb: "Ocena Airbnb",
  abonnement: "Prenumerata",
  europe_unique___50eur_an: "Jedna Europa - 50EUR/rok",
  offre_lancement_2026__25eur_an___50__:
    "Oferta wprowadzenia na rynek 2026: 25 EUR/rok (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Cena gwarantowana dożywotnio dla pierwszych 1000 rejestracji.",
  mot_de_passe: "Hasło",
  "8_caract_res_minimum": "Minimum 8 znaków",
  connexion___: "Połączenie...",
  cr_ation_du_compte___: "Tworzenie konta...",
  se_connecter: "Zaloguj się",
  cr_er_mon_compte: "Utwórz moje konto",
  mot_de_passe_oubli___: "Zapomniałeś hasła?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "Tworząc konto wyrażasz zgodę na nasze",
  cgu: "CGU",
  _et_notre_: "i nasze",
  politique_de_confidentialit_: "Polityka prywatności",
  r_servation_de_logements: "Rezerwacja noclegu",
  support_h_te_prioritaire: "Priorytetowa pomoc dla gospodarzy",
  carte___filtres_avanc_s: "Mapa + zaawansowane filtry",
  flux_de_r_servation__tape_par__tape: "Przebieg rezerwacji krok po kroku",
  couverture_dommages_assistance: "Ubezpieczenie od szkód/pomocy",
  multi_logements___reporting: "Wielomieszkaniowość + raportowanie",
  comparatif_des_modes: "Porównanie trybów",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Co aktywujesz zgodnie z użytkowaniem TRAVELTROK.",
  fonction: "Funkcjonować",
  voyageur: "Podróżny",
  pro: "Zawodowiec",
  abonnement_europe_unique: "Subskrypcja Jednolitej Europy",
  rejoindre_le_club_europe: "Dołącz do klubu Europy",
  basse_saison: "Niski sezon",
  pause: "Zrób sobie przerwę",
  rencontres: "Poznaj gospodarzy",
  _conomies: "Oszczędności",
  quota_atteint: "Limit osiągnięty",
  _ligibilit_: "Uprawnienia",
  zone_d__change: "Obszar wymiany",
  toute_l_europe: "Cała Europa",
  mod_le: "Model",
  abonnement_unique_annuel: "Pojedyncza roczna subskrypcja",
  propri_taire_europ_en_en_pause: "Europejski właściciel na przerwie",
  v_rification: "Weryfikacja",
  h_tes_certifi_s: "Certyfikowani gospodarze",
  abonnement_unique_traveltrok: "Pojedyncza subskrypcja DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Oferta na rok 2026: 25 EUR/rok zamiast 50 EUR/rok",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Dlaczego ten klub pracuje dla gospodarzy",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "W DONKEY TRAVEL Twoje dane nie są produktem.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Nigdy nie sprzedajemy informacji o naszych członkach.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Nie udostępniamy żadnych danych podmiotom trzecim w celach komercyjnych.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "Strona jest bezpieczna, a Twoje wymiany pozostają prywatne.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL gwarantuje brak reklam: jesteś członkiem, a nie produktem.",
  rejoindre_le_club: "Dołącz do klubu",
  trouver_un_h_te: "Znajdź gospodarza",
  proposer_un__change: "Zaproponuj wymianę",
  synchronisation_mise___jour_avec_succ_s:
    "Synchronizacja została pomyślnie zaktualizowana",
  erreur_lors_de_la_mise___jour: "Błąd podczas aktualizacji",
  indisponible: "Nie płynny",
  r_serv_: "Zarezerwować",
  erreur_chargement: "Błąd ładowania",
  inconnue: "Nieznany",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Nie można odzyskać kalendarza iCal. Sprawdź adres URL iCal Airbnb i spróbuj ponownie.",
  r_servation: "Rezerwacja",
  _v_nements_synchronis_s: "zsynchronizowane wydarzenia",
  _v_nements_import_s: "zaimportowane wydarzenia",
  erreur_sync: "Błąd synchronizacji",
  _chec_de_synchronisation: "Błąd synchronizacji",
  dates_bloqu_es_avec_succ_s: "Daty zablokowano pomyślnie",
  erreur_blocage: "Błąd blokowania",
  mois: "Miesiąc",
  aujourd_hui: "Dzisiaj",
  d_tails: "Bliższe dane",
  actions: "Działania",
  bloquer: "Aby zablokować",
  filtres: "Filtry",
  confirm_: "Potwierdzony",
  en_attente: "Wstrzymane",
  proposition: "Wniosek",
  bloqu_: "Zablokowany",
  synchronisation: "Synchronizacja",
  configurer: "Skonfiguruj",
  airbnb_connect_: "Połączono z Airbnb",
  derni_re_synchro_r_ussie: "Ostatnia udana synchronizacja",
  derni_re_synchro_en__chec: "Ostatnia nieudana synchronizacja",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Połączony kalendarz. Rozpocznij synchronizację, aby zaimportować rezerwacje Airbnb.",
  synchro___: "Synchronizuj...",
  forcer_la_synchro: "Wymuś synchronizację",
  non_synchronis_: "Brak synchronizacji",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Połącz swój kalendarz Airbnb, aby uniknąć podwójnych rezerwacji!",
  bloquer_des_dates: "Blokuj daty",
  s_lection: "Wybór",
  jours: "dni",
  raison__optionnel__ex__travaux_: "Powód (opcjonalnie, np.: Prace)",
  annuler: "Anulować",
  confirmer: "Potwierdzać",
  synchronisation_airbnb: "Synchronizacja Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Dodaj linki do Airbnb, aby automatycznie synchronizować rezerwacje i unikać duplikatów.",
  lien_de_l_annonce_airbnb: "Link do reklamy Airbnb",
  airbnb_ical_calendar_link: "Link do kalendarza Airbnb iCal",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Dostępne w Ustawieniach ogłoszeń Eksport kalendarza",
  enregistrer: "Ratować",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Przed kontynuowaniem kliknij przycisk „Zlokalizuj”, aby potwierdzić adres.",
  vous_devez__tre_connect__pour_publier_:
    "Aby opublikować post, musisz się zalogować.",
  id_manquant_apr_s_sauvegarde:
    "Brak identyfikatora po utworzeniu kopii zapasowej",
  erreur_upload_photo: "Błąd przesyłania zdjęć",
  erreur_sauvegarde_metadata_photos:
    "Błąd podczas zapisywania zdjęć z metadanymi",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "Wystąpił błąd podczas zapisywania",
  quitter: "Wyjechać",
  modification: "Redagować",
  cr_ation: "Tworzenie",
  _tape: "Scena",
  sur: "NA",
  sauvegarde_en_cours___: "Tworzenie kopii zapasowej w toku...",
  retour: "Z powrotem",
  sauvegarde___: "Kopia zapasowa...",
  mettre___jour: "Aby zaktualizować",
  publier_l_annonce: "Opublikuj ogłoszenie",
  suivant: "Następny",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Czy na pewno chcesz usunąć tę reklamę?",
  impossible_de_supprimer_l_annonce__: "Nie można usunąć reklamy:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Zarządzaj swoimi miejscami noclegowymi i ich dostępnością.",
  ajouter_une_annonce: "Dodaj ogłoszenie",
  vous_n_avez_aucune_annonce: "Nie masz żadnych reklam",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Zacznij zarabiać wynajmując swój dom. To szybkie i łatwe.",
  cr_er_ma_premi_re_annonce: "Utwórz moją pierwszą reklamę",
  publi_: "Opublikowany",
  brouillon: "Projekt",
  __nuit: "/ noc",
  voir_l_annonce: "Zobacz reklamę",
  modifier: "Aby zmodyfikować",
  supprimer: "USUWAĆ",
  quels__quipements_proposez_vous__: "Jaki sprzęt oferujecie?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Wybierz wszystko, co jest dostępne dla podróżnych.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Nie znaleziono kompatybilnego diagramu konwersacji.",
  logements_concern_s: "dane mieszkanie",
  logement_non_pr_cis_: "Zakwaterowanie nieokreślone",
  erreur_lors_de_l_envoi_du_message_: "Błąd podczas wysyłania wiadomości.",
  rechercher_une_conversation: "Wyszukaj rozmowę",
  demandes_re_ues: "Otrzymane prośby",
  mes_demandes: "Moje prośby",
  aucune_demande_re_ue_: "Nie otrzymano żadnych żądań.",
  aucune_demande_envoy_e_: "Nie wysłano żadnego żądania.",
  photo_de_profil: "Zdjęcie profilowe",
  localisation_non_pr_cis_e: "Nie określono lokalizacji",
  listing_: "Wymienianie kolejno:",
  en_ligne: "W Internecie",
  vous: "TY",
  _crivez_votre_message___: "Napisz swoją wiadomość...",
  s_lectionnez_une_conversation: "Wybierz rozmowę",
  pour_commencer___changer: "aby rozpocząć handel",
  logement_propos_: "Proponowane zakwaterowanie",
  description_non_pr_cis_e: "Opis nieokreślony",
  ch_: "rozdz.",
  voy_: "Widzieć.",
  nuit: "noc",
  prix_non_pr_cis_: "Cena nieokreślona",
  voir: "Widzieć",
  aucune_annonce_li_e___cette_conversation_:
    "Brak ogłoszeń związanych z tą rozmową.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Wybierz rozmowę, aby zobaczyć szczegóły.",
  bonjour: "Dzień dobry",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Oto, co dzieje się dzisiaj na Twoim koncie.",
  annonces_en_ligne: "Reklamy w Internecie",
  nouveaux_messages: "Nowe posty",
  prochains__changes: "Następne wymiany",
  matching_section__o__je_veux_aller: "Pasująca sekcja: Gdzie chcę pojechać",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Dodaj maksymalnie 10 miast o promieniu w km i dacie wyjazdu, aby otrzymywać bardziej ukierunkowane propozycje.",
  configurer_mes_pr_f_rences: "Skonfiguruj moje preferencje",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Gotowy na przyjęcie pierwszych podróżników?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Uzupełnij swój profil i opublikuj swoje pierwsze ogłoszenie, aby rozpocząć wymianę zakwaterowania ze społecznością TravelWymiana.",
  cr_er_mon_annonce: "Utwórz moją reklamę",
  compl_ter_mon_profil: "Uzupełnij mój profil",
  impossible_de_charger_vos_preferences_:
    "Nie można załadować Twoich preferencji.",
  preferences_enregistrees_: "Zapisane preferencje.",
  impossible_d_enregistrer_vos_preferences_:
    "Nie można zapisać Twoich preferencji.",
  impossible_de_supprimer_votre_profil_: "Nie można usunąć Twojego profilu.",
  chargement_des_preferences___: "Ładowanie preferencji...",
  unites_de_distance: "Jednostki odległości",
  kilom_tres__km_: "Kilometry (km)",
  format_europeen_par_defaut: "Domyślny format europejski",
  miles__mi_: "Mile (mi)",
  format_anglo_saxon: "Format anglosaski",
  visibilite_du_profil: "Widoczność profilu",
  mettre_mon_profil_en_pause: "Wstrzymaj mój profil",
  me_masquer_dans_les_resultats_de_recherche:
    "Ukryj mnie w wynikach wyszukiwania",
  zone_sensible: "Wrażliwy obszar",
  suppression___: "Usunięcie...",
  supprimer_mon_profil: "Usuń mój profil",
  pensez_a_enregistrer_vos_modifications_: "Pamiętaj o zapisaniu zmian.",
  enregistrement___: "Rejestracja...",
  enregistrer_les_preferences: "Zapisz preferencje",
  impossible_de_charger_votre_profil_: "Nie można załadować Twojego profilu.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Profil został częściowo zapisany. Należy zaktualizować bazę danych (migracja SQL).",
  profil_mis___jour_avec_succ_s_: "Profil został pomyślnie zaktualizowany.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Profil nie został zapisany: należy przeprowadzić migrację bazy danych (brakujące kolumny).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Profil nie został zapisany: brakuje zbyt wielu kolumn. Rozpocznij migrację SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Twoja baza danych jest nieaktualna. Uruchom migrację SQL i spróbuj ponownie.",
  erreur_lors_de_la_mise___jour_: "Błąd podczas aktualizacji.",
  photo_de_profil_mise___jour_: "Zaktualizowane zdjęcie profilowe.",
  erreur_upload_photo_: "Błąd przesyłania zdjęć.",
  photo_de_couverture_mise___jour_: "Zaktualizowane zdjęcie na okładce.",
  erreur_upload_couverture_: "Błąd przesyłania okładki.",
  document_envoy__pour_v_rification_: "Dokument przesłany do weryfikacji.",
  erreur_lors_de_l_envoi_du_document_: "Błąd podczas wysyłania dokumentu.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "W tej chwili nie można załadować Twojego profilu.",
  mon_profil_h_te: "Mój profil hosta",
  identit___r_seaux_et_infos_de_matching:
    "Tożsamość, sieci i informacje o dopasowywaniu",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Im bardziej kompletny jest Twój profil, tym bardziej kompatybilne hosty może zasugerować silnik.",
  compl_tude_du_profil: "Kompletność profilu",
  couverture: "Koc",
  photo_principale: "Główne zdjęcie",
  h_te_traveltrok: "Gospodarz DONKEY TRAVEL",
  localisation_non_renseign_e: "Nie podano lokalizacji",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Dodaj duże zdjęcie, aby lepiej zaprezentować świat gospodarzy.",
  destinations_cibl_es: "Ukierunkowane miejsca docelowe",
  dates_pr_vues: "Planowane daty",
  configurer___o__je_veux_aller__: "Skonfiguruj „Gdzie chcę jechać”",
  statut_identit_: "Stan tożsamości",
  v_rifi_: "Zweryfikowano",
  en_cours: "W toku",
  non_v_rifi_: "Nie zweryfikowano",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Dodaj identyfikator, aby zbudować zaufanie społeczności.",
  envoyer_document: "Wyślij dokument",
  identit__et_contact: "Tożsamość i kontakt",
  pr_nom: "Imię",
  nom: "Nazwa",
  pseudo_public: "Pseudonim publiczny",
  email: "E-mail",
  t_l_phone: "Telefon",
  r_seaux_et_liens: "Sieci i linki",
  site_web: "Strona internetowa",
  localisation_et_mode_de_voyage: "Lokalizacja i sposób podróżowania",
  pays_de_r_sidence: "Kraj zamieszkania",
  s_lectionnez_un_pays: "Wybierz kraj",
  ville_de_r_sidence: "Miasto zamieszkania",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "Ile osób podróżuje?",
  voyagez_vous_avec_des_animaux__: "Czy podróżujesz ze zwierzętami?",
  oui: "Tak",
  non: "NIE",
  voyagez_vous_avec_des_b_b_s__: "Podróżujesz z dziećmi?",
  bio_h_te: "Biografia gospodarza",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Przedstaw swój styl gościnności i zakwaterowanie.",
  pr_sentation_de_la_famille: "Prezentacja rodziny",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Kto podróżuje, nawyki, tempo, poszukiwany rodzaj pobytu...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Wypełnij także „Dokąd chcę jechać”, aby aktywować dokładniejsze dopasowanie.",
  enregistrer_le_profil: "Zapisz profil",
  horizon_contrat: "Horyzont kontraktu",
  "24_mois_apres_le_1er_sejour": "24 miesiące od pierwszego pobytu",
  nuits_que_je_dois: "Noce, które jestem winien",
  nuits_qu_on_me_doit: "Noce, które jestem winien",
  echanges_ouverts: "Otwarte wymiany",
  echanges_proches_echeance: "Transakcje bliskie terminu zapadalności",
  alerte_solde_des_echanges: "Powiadomienie o saldzie wymiany",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "W tej chwili nie wykryto żadnego profilu ryzyka.",
  contrats_en_cours: "Aktualne umowy",
  personne: "Osoba",
  logement: "Zakwaterowanie",
  contrat: "UMOWA",
  dates: "Daty",
  echange_effectue: "Wymiana dokonana",
  solde_nuits: "Noce sprzedaży",
  temps_restant: "Pozostały czas",
  "1er_sejour_": "Pierwszy pobyt:",
  echeance_: "Termin:",
  ils_sont_venus__fait: "Przyszli: gotowe",
  ils_sont_venus__en_attente: "Przyszli: czekają",
  je_suis_alle__fait: "Poszedłem: gotowe",
  je_suis_alle__en_attente: "Poszedłem: czekam",
  je_dois: "Muszę",
  nuits: "noce",
  on_me_doit: "Jestem dłużny",
  carte_des_p_rim_tres_de_recherche: "Mapa obszarów badawczych",
  villes_localis_es: "zlokalizowane miasta",
  mise___jour_de_la_carte___: "Aktualizowanie mapy...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Aby zarządzać swoimi preferencjami, musisz się zalogować.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "W tej chwili nie można załadować pasujących preferencji.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Dodaj co najmniej jedno miasto docelowe, aby aktywować dopasowanie.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Okres ma datę końcową wcześniejszą niż data początkowa.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Wybierz co najmniej jeden kraj, jeśli włączysz filtr kontaktów według kraju.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Zapisane preferencje. Kraje docelowe są przechowywane lokalnie do czasu zastosowania migracji SQL.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Pasujące preferencje zostały pomyślnie zapisane.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Preferencje nie zostały zapisane: baza danych nie została przeniesiona. Rozpocznij migrację SQL.",
  erreur_lors_de_l_enregistrement_: "Błąd podczas zapisywania.",
  matching_intelligent: "Inteligentne dopasowanie",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Wskaż miasta docelowe i terminy wyjazdu: DONKEY TRAVEL będzie w stanie zaoferować najbardziej kompatybilnych gospodarzy.",
  retour_au_profil: "Powrót do profilu",
  villes_et_rayon_de_recherche: "Miasta i promień wyszukiwania",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Do 10 miast (np.: Amiens 2 km, Paryż 5 km, Lille 20 km).",
  villes_actives: "aktywnych miast",
  ville: "Miasto",
  choisir_un_pays: "Wybierz kraj",
  saisissez_une_ville: "Wpisz miasto",
  choisissez_le_pays_d_abord: "Najpierw wybierz kraj",
  rayon: "Promień",
  supprimer_cette_ville: "Usuń to miasto",
  ajouter_une_ville: "Dodaj miasto",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Miasta te będą wykorzystywane do oferowania ukierunkowanych wymian.",
  enregistrer_mes_pr_f_rences: "Zapisz moje preferencje",
  pays_d_europe___visiter: "Kraje europejskie, które warto odwiedzić",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Sprawdź kraje, które Cię interesują. Możesz wówczas ograniczyć kontakty do tych krajów.",
  pays_s_lectionn_s: "wybrane kraje",
  tout_cocher: "Sprawdź wszystko",
  tout_d_cocher: "Odznacz wszystko",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Kontaktuj się wyłącznie z członkami z tych krajów",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Ten filtr zostanie użyty podczas automatycznego dopasowywania.",
  union_europ_enne: "Unia Europejska",
  hors_union_europ_enne: "Poza Unią Europejską",
  agenda_des_d_parts_souhait_s: "Harmonogram wybranych odjazdów",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Dodaj okresy, w których chcesz wyjść, aby rozpocząć dopasowywanie na wspólnych automatach.",
  p_riode_s__active_s_: "aktywne okresy",
  aucune_p_riode_ajout_e_pour_le_moment_: "Nie dodano jeszcze żadnych okresów.",
  p_riode: "Okres",
  supprimer_cette_p_riode: "Usuń ten okres",
  d_part: "Wyjazd",
  commentaire__optionnel_: "Komentarz (opcjonalnie)",
  ajouter_une_p_riode: "Dodaj okres",
  r_sum__matching: "Dopasowanie podsumowujące",
  villes_cibles: "Kieruj na miasta",
  rayon_moyen: "Średni promień",
  p_riodes_planifi_es: "Planowane okresy",
  pays_cibl_s: "Kraje docelowe",
  contacts_limit_s_aux_pays_coch_s:
    "Kontakty ograniczone do sprawdzonych krajów",
  contacts_ouverts___tous_les_pays: "Kontakty otwarte dla wszystkich krajów",
  agenda_aper_u: "Przegląd programu",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Dodaj okres, aby wyświetlić kalendarz odlotów.",
  sans_commentaire: "Bez komentarza",
  logement_traveltrok: "Zakwaterowanie DONKEY TRAVEL",
  localisation_a_preciser: "Lokalizacja do ustalenia",
  logements_trouves: "znaleziono zakwaterowanie",
  plus_recents: "Najnowsze",
  capacite_max: "Maksymalna pojemność",
  h_tes: "Zastępy niebieskie",
  villes: "Miasta",
  logements_disponibles: "Dostępne zakwaterowanie",
  pays_disponibles: "Dostępne kraje",
  marie_accepte__: "Maria akceptuje!",
  nuits_a_reims_contre: "wieczory w Reims przeciwko",
  nuits_a_paris: "noce w Paryżu",
  l_histoire_de_marie_jean: "Historia Marii i Jeana",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie zagląda do pamiętnika Jeana",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Widzi, że Jean ma wolne terminy za 2 tygodnie. Idealny dla niej! Jean potwierdza, że ​​może opublikować te daty.",
  h_tes_actifs: "Aktywni gospodarze",
  pays_couverts: "Kraje objęte",
  echanges_realises: "Dokonano wymiany",
  "100__match": "100% dopasowania",
  echanges_longue_distance: "Wymiany na odległość",
  matching_algorithmique_intelligent: "Inteligentne dopasowanie algorytmiczne",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Nasz algorytm łączy informacje z Twojego profilu i Twoich wyszukiwań, aby zaoferować Ci wszystkie ogłoszenia mieszkaniowe, które dokładnie odpowiadają Twojemu zapytaniu.",
  matching_precis: "Precyzyjne dopasowanie",
  analyse_intelligente_de_vos_crit_res: "Inteligentna analiza Twoich kryteriów",
  gain_de_temps_dans_vos_recherches: "Oszczędź czas na badaniach",
  propositions_ultra_pertinentes: "Niezwykle trafne propozycje",
  habitants: "mieszkańcy",
  destinations_europeennes: "Cele podróży w Europie",
  decouvrez_les_merveilles_du_continent: "Odkryj cuda kontynentu",
  pays_actifs_sur_traveltrok: "Kraje aktywne w DONKEY TRAVEL",
  selectionner_un_pays: "Wybierz kraj",
  union_europeenne: "Unia Europejska",
  hors_union_europeenne: "Poza Unią Europejską",
  fiche_detaillee: "Szczegółowy arkusz",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Wybierz kraj z listy lub na mapie, aby odkryć klimat, populację i charakterystyczne miejsca.",
  logements_actifs: "mieszkanie aktywne",
  climat: "Klimat",
  information_touristique: "Informacja turystyczna",
  lieux_emblematiques: "Ikoniczne miejsca",
  gastronomie: "Gastronomia",
  dom_tom___outre_mer: "DOM-TOM / Za granicą",
  villes_principales: "Główne miasta",
  charte_officielle: "Oficjalny statut",
  confiance_mutuelle: "Wzajemne zaufanie",
  r_gles_claires: "Jasne zasady",
  sanctions_applicables: "Obowiązujące sankcje",
  illustration_3d_des_engagements: "Ilustracja 3D zobowiązań",
  concept_3d_informations: "Obraz 3D szczegółów",
  principe_1: "Zasada 1",
  v_racit__des_informations: "Prawdziwość informacji",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Profil, zakwaterowanie, zdjęcia i ceny muszą być dokładne.",
  concept_3d_respect_du_lieu: "Obraz 3D szacunku dla miejsca",
  principe_2: "Zasada 2",
  respect_du_lieu: "Szacunek dla tego miejsca",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Żadnych imprez i żadnych uciążliwości dla okolicy.",
  concept_3d_fiabilit__contractuelle: "Koncepcja kontraktu w 3D",
  principe_3: "Zasada 3",
  fiabilit__contractuelle: "Rzetelność kontraktowa",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Zablokowane daty = zdecydowane zobowiązanie, chyba że istnieje ważny powód.",
  engagements_c_t__voyageur: "Zobowiązania po stronie pasażera",
  engagements_c_t__h_te: "Zobowiązania po stronie gospodarza",
  annulations_et_reports: "Anulacje i przełożenia",
  r_gle_op_rationnelle: "Zasada operacyjna",
  check_list_d_part_voyageur: "Lista kontrolna wyjazdu",
  cuisine_et_vaisselle_propres: "Czysta kuchnia i naczynia",
  sols_et_surfaces_rendus_propres: "Podłogi i powierzchnie wyczyszczone",
  linge_utilis__d_pos__selon_consigne:
    "Zużyta pościel oddana zgodnie z instrukcją",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Żadnych nieautoryzowanych zaproszeń",
  _tat_final_du_logement_confirm__avec_photos:
    "Potwierdzono ostateczny stan mieszkania",
  sanctions_en_cas_de_manquement:
    "Sankcje w przypadku nieprzestrzegania przepisów",
  ce_que_permet_traveltrok: "Na co pozwala DONKEY TRAVEL",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Możesz dodać dowolną liczbę obiektów noclegowych.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Wymiana bez limitu powtarzalności w ciągu roku.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Formalna umowa oficjalnie wiąże gospodarzy i gwarantuje sukces.",
  r_f_rences_de_bonnes_pratiques: "Referencje najlepszych praktyk",
  un_club_s_rieux__une_communaut__durable:
    "Poważny klub tworzy trwałą społeczność",
  retour_au_guide_complet: "Powrót do pełnego przewodnika",
  carte_des_logements_traveltrok: "Mapa zakwaterowania DONKEY TRAVEL",
  points_logements: "Punkty noclegowe",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "W tej chwili brak danych geolokalizacyjnych.",
  envie_d_entrer_dans_la_carte__: "Chcesz dostać się na mapę?",
  chargement_des_logements___: "Ładowanie obudowy...",
  la_date_d_arriv_e_est_requise: "Wymagana jest data przyjazdu",
  la_date_ne_peut_pas__tre_dans_le_pass_:
    "Data nie może przypadać w przeszłości",
  la_date_de_d_part_est_requise: "Wymagana jest data wyjazdu",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "Data wyjazdu musi przypadać po przylocie",
  le_message_doit_contenir_au_moins_10_caract_res:
    "Wiadomość musi zawierać co najmniej 10 znaków",
  veuillez_corriger_les_erreurs_ci_dessus: "Popraw powyższe błędy",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Wystąpił błąd. Spróbuj ponownie.",
  paris__france: "Paryż, Francja",
  mode_h_te: "Tryb hosta",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Wynajmuję na kilka tygodni w roku. Model 1 EUR za noc jest bardzo prosty do wyjaśnienia podróżnym.",
  "37_nuits": "37 nocy",
  lyon__france: "Lyon, Francja",
  mode_voyageur: "Moda podróżnicza",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "Rezerwacja przebiega sprawnie, a przede wszystkim opłaty są czytelne. Z łatwością porównuję ostateczny koszt przed potwierdzeniem.",
  "22_nuits": "22 noce",
  bordeaux__france: "Bordeaux, Francja",
  "54_nuits": "54 noce",
  marseille__france: "Marsylia, Francja",
  pro_multi_logements: "Profesjonalne wielomieszkaniowe",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Dzięki wielu właściwościom wersja Pro pozwala mi zaoszczędzić dużo czasu na planowaniu i zarządzaniu żądaniami.",
  "9_logements": "9 miejsc noclegowych",
  retours_utilisateurs: "Informacje zwrotne od użytkowników",
  des_retours_terrain_concrets: "Konkretna informacja zwrotna z pola",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Podróżni i gospodarze, którzy chcą bardziej przejrzystego i tańszego wynajmu.",
  activit_: "działalność",
  _conomie_estim_e: "szacunkowe oszczędności",
  profils_et_logements_v_rifi_s: "Zweryfikowane profile i zakwaterowanie",
  exp_rience_location_simplifi_e: "Uproszczona obsługa wynajmu",
  co_ts_transparents___la_nuit: "Przejrzyste koszty w nocy",
  marquer_des_dates: "Zaznacz daty",
  je_peux_accueillir: "Mogę się pomieścić",
  je_veux_partir: "Chcę wyjechać",
  partir_et_accueillir: "Odejdź i powitaj",
  accueillir: "Powitać",
  partir: "Wyjechać",
  bloquer_les_dates: "Blokuj daty",
  toujours_partir_et_accueillir: "Zawsze wychodź i witaj",
  rendre_ce_logement_visible: "Spraw, aby to zakwaterowanie było widoczne",
  rendre_ce_logement_invisible: "Spraw, aby to zakwaterowanie było niewidoczne",
  confirmation_visibilite_logement:
    "Czy na pewno chcesz zmienić widoczność TEGO wpisu dla innych członków?",
  confirmer_activer_toujours_partir_accueillir:
    "Aktywując ten tryb, zostaną dodane nowe możliwości „Wyjdź i powitaj”, które zawsze będą obowiązywać przez kolejne 2 lata od dzisiaj. Inne ręczne możliwości zostaną zastąpione.\n\nCzy na pewno chcesz kontynuować?",
  confirmer_desactiver_toujours_partir_accueillir:
    "Czy na pewno chcesz wyłączyć tryb „Zawsze wychodź i pozdrawiaj”?",
  details_de_l_adresse__optionnel_: "Dane adresowe (opcjonalnie)",
  rue_et_numero: "Ulica i numer",
  ex__12_rue_de_la_paix: "Np.: 12 rue de la Paix",
  appartement_suite: "Mieszkanie, apartament itp.",
  ex__apt_4b: "Przykład: apartament 4B",
  etage: "Podłoga",
  ex__3eme_sans_ascenseur: "Np.: 3",
  code_d_acces: "Kod dostępu (drzwi/budynek)",
  ex__a1234: "Np.: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Te szczegółowe informacje zostaną przekazane wyłącznie członkom, którzy mają potwierdzoną wymianę zdań z Tobą.",
  lits_doubles: "Podwójne łóżka",
  lits_simples: "Pojedyncze łóżka",
  canapes_lits: "Sofy rozkładane",
  lits_bebes: "Łóżeczka dziecięce",
  amenity_cat_essentials: "Najważniejsze",
  amenity_cat_kitchen: "Gotowanie i posiłki",
  amenity_cat_bathroom: "Łazienka",
  amenity_cat_bedroom_laundry: "Sypialnia i pościel",
  amenity_cat_entertainment: "Rozrywka",
  amenity_cat_family: "Rodzina",
  amenity_cat_exterior: "Poza",
  amenity_cat_features: "Cechy",
  amenity_cat_location: "Lokalizacja",
  amenity_cat_safety: "Bezpieczeństwo",
  amenity_wifi: "Wi-Fi",
  amenity_workspace: "Dedykowana przestrzeń robocza",
  amenity_ac: "Klimatyzacja",
  amenity_heating: "Ogrzewanie",
  amenity_kitchen: "Kuchnia",
  amenity_refrigerator: "Lodówka",
  amenity_microwave: "Mikrofalowy",
  amenity_oven: "Piekarnik",
  amenity_dishwasher: "Pomywaczka",
  amenity_coffee_maker: "Ekspres do kawy",
  amenity_kettle: "Czajnik",
  amenity_bathtub: "Wanna",
  amenity_hair_dryer: "suszarka do włosów",
  amenity_shampoo: "Szampon i żel pod prysznic",
  amenity_hot_water: "Tarapaty",
  amenity_washing_machine: "Pralka",
  amenity_dryer: "Suszarka",
  amenity_iron: "Żelazo",
  amenity_hangers: "Wieszaki",
  amenity_bed_linens: "Pościel zapewniona",
  amenity_tv: "Telewizja",
  amenity_game_console: "Konsola do gier",
  amenity_books_toys: "Książki i zabawki",
  amenity_sound_system: "System audio",
  amenity_high_chair: "Wysokie krzesełko",
  amenity_baby_bath: "Kąpiel dziecka",
  amenity_travel_cot: "Łóżeczko turystyczne",
  amenity_changing_table: "Zmiana stołu",
  amenity_patio: "Balkon lub taras",
  amenity_garden: "Prywatny ogród",
  amenity_bbq: "Rożen",
  amenity_outdoor_furniture: "Meble ogrodowe",
  amenity_pool: "Basen",
  amenity_hottub: "jacuzzi",
  amenity_gym: "Sala gimnastyczna",
  amenity_fireplace: "Komin",
  amenity_breakfast: "Śniadanie wliczone w cenę",
  amenity_parking: "Parking bezpłatny",
  amenity_ev_charger: "Stacja ładowania pojazdów elektrycznych",
  amenity_beachfront: "Dostęp do plaży",
  amenity_ski_in_out: "Dostęp do stoków narciarskich",
  amenity_lake_access: "Dostęp do jeziora",
  amenity_smoke_detector: "Detektor dymu",
  amenity_first_aid: "Zestaw pierwszej pomocy",
  amenity_fire_extinguisher: "Gaśnica",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Fotel do masażu",
  amenity_shower: "Prysznic",
  amenity_home_cinema: "Kino domowe",
  amenity_ping_pong: "Stół do ping-ponga",
  amenity_forest_access: "Dostęp do lasu",
  amenity_hiking_access: "Dostęp do turystyki pieszej",
  compl_t_: "zakończony",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "Adres musi znajdować się na mapie",
  au_moins_3_photos_requises: "Wymagane są co najmniej 3 zdjęcia",
  le_titre_doit_faire_au_moins_10_caract_res:
    "Tytuł musi mieć co najmniej 10 znaków",
  la_description_doit_faire_au_moins_50_caract:
    "Opis musi mieć co najmniej 50 znaków",
  s_lectionnez_au_moins_3_quipements: "Wybierz co najmniej 3 urządzenia",
  encore_quelques_d_tails_avant_de_publier:
    "Jeszcze kilka szczegółów przed publikacją",
  votre_annonce_est_compl_t_e_x:
    "Twoja reklama jest ukończona w {{score}}%. Aby móc go opublikować, prosimy o uzupełnienie brakujących elementów:",
  compl_ter: "Kompletny",
  voici_comment_les_voyageurs_verront_votre_:
    "W ten sposób podróżni będą widzieć Twoją ofertę.",
  photo: "Zdjęcie",
  afficher_toutes_les_photos: "Pokaż wszystkie zdjęcia",
  h_t_par_vous: "• Gospodarz: Ty",
  description: "O tym zakwaterowaniu",
  votre_description_appara_tra_ici: "Twój opis pojawi się tutaj...",
  afficher_les_n__quipements_x: "Pokaż im{{count}}sprzęt",
  ajouter_une_date: "Dodaj datę",
  aucun_montant_ne_vous_sera_d_bit_:
    "W tym momencie nie zostaniesz obciążony żadną kwotą",
  demander: "Zapytać",
  enregistrer_et_quitter: "Zapisz i wyjdź",
  enregistrer_pour_plus_tard: "Zapisz na później",
  conseils_pour_des_photos_r_ussies: "Wskazówki dotyczące udanych zdjęć",
  privil_giez_le_format_paysage__1:
    "Wybierz format poziomy (16:9), aby uzyskać lepszy obraz.",
  prenez_vos_photos_de_jour__avec_:
    "Rób zdjęcia w ciągu dnia, przy dobrym naturalnym świetle.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Przechowuj i czyść elementy przed ich sfotografowaniem.",
  mettez_en_avant_les_atouts_de_vo:
    "Podkreśl atuty swojego zakwaterowania (widok, taras, piękny salon itp.).",
  donnez_un_titre___votre_annonce: "Nadaj tytuł swojej reklamie",
  un_titre_court_et_accrocheur_attirera_pl:
    "Krótki i chwytliwy tytuł przyciągnie więcej podróżnych.",
  souhaite_visiter: "Chciałbym odwiedzić",
  vous_propose_en_change: "Oferuje w zamian",
  autres_logements: "inne zakwaterowanie",
  voir_le_logement: "Zobacz zakwaterowanie",
  votre_demande_titre: "Twoja prośba",
  votre_demande_soustitre:
    "Podsumowanie Twoich pragnień związanych z podróżą i towarzyszami przyszłych wymian.",
  compagnons_de_voyage: "Towarzysze podróży",
  voyage_avec_bebe: "Niemowlęta)",
  voyage_avec_animaux: "Zwierzęta",
  disponibilites_souhaitees: "Pożądana dostępność",
  destinations_cibles: "Cele docelowe",
  aucune_date_precisee: "Nie podano daty podróży.",
  aucune_destination_precisee: "Nie określono docelowego miejsca docelowego.",
  votre_demande_menu: "Twoja prośba",
  modifier_mon_profil: "Edytuj mój profil",
  rayon_de: "Promień{{km}}km",
  dates_flexibles_option: "Elastyczne terminy",
  animaux_de_compagnie_details: "{{count}}zwierzę/zwierzęta",
  changer_d_annonce: "Zmień reklamę",
  profil_du_voyageur: "Profil podróżnika",
  chambres_requises: "Wymagane pokoje",
  animaux: "zwierzę (zwierzęta)",
  duree_du_sejour_souhaitee: "Pożądana długość pobytu",
  combien_de_chambres_avez_vous_besoin__: "Ile sypialni potrzebujesz?",
  combien_de_b_b_s__: "Ile dzieci?",
  combien__: "Ile ?",
  vos_animaux: "Twoje zwierzęta",
  chien_s_: "Pies(-y)",
  plus_de_30_nuits: "Ponad 30 nocy",
  "community.hero.badge": "Nasza społeczność",
  "community.hero.title": "Dołącz do najbardziej autentycznej sieci hostów",
  "community.hero.subtitle":
    "Udostępnij więcej niż tylko swój dom. Odkrywaj historie, spotykaj pełnych pasji gospodarzy i podróżuj bez obaw.",
  "community.stats.members": "Aktyw",
  "community.stats.countries": "Reprezentowane kraje",
  "community.stats.exchanges": "Dokonano wymiany",
  "community.values.title": "Co nas łączy",
  "community.values.trust.title": "Absolutna pewność",
  "community.values.trust.desc":
    "Każdy członek jest zweryfikowanym gospodarzem, gwarantującym wzajemny szacunek do lokalu.",
  "community.values.sharing.title": "Udostępnianie i spotkania",
  "community.values.sharing.desc":
    "Możliwość nawiązania kontaktów z mieszkańcami całej Europy.",
  "community.values.savings.title": "Prawdziwe oszczędności",
  "community.values.savings.desc":
    "Podróżuj częściej i dalej, oszczędzając budżet.",
  "community.testimonials.title": "Historie członków",
  "community.cta.title": "Gotowy, aby wziąć udział w przygodzie?",
  "community.cta.button": "Zostań członkiem już dziś",
  "blog.hero.badge": "Nasz blog",
  "blog.hero.title": "Inspiracje i porady",
  "blog.hero.subtitle":
    "Odkryj historie z podróży, wskazówki dotyczące przygotowania noclegu i nowości w klubie.",
  "blog.categories.all": "Wszystkie artykuły",
  "blog.categories.tips": "Wskazówki gospodarza",
  "blog.categories.inspiration": "Inspiracje podróżnicze",
  "blog.categories.news": "Aktualności",
  "blog.empty": "Brak artykułów w tej chwili. Wróć wkrótce!",
  "help.hero.badge": "Centrum pomocy",
  "help.hero.title": "Jak możemy Ci pomóc?",
  "help.hero.subtitle":
    "Znajdź szybkie odpowiedzi lub skontaktuj się z naszym zespołem wsparcia.",
  "help.search.placeholder": "Szukaj odpowiedzi...",
  "help.categories.account.title": "Konto i profil",
  "help.categories.account.desc":
    "Zarządzaj swoimi informacjami, hasłami i preferencjami.",
  "help.categories.exchanges.title": "Wymiany i rezerwacje",
  "help.categories.exchanges.desc":
    "Jak zaoferować, zaakceptować lub anulować wymianę.",
  "help.categories.trust.title": "Zaufanie i bezpieczeństwo",
  "help.categories.trust.desc": "Umowy, weryfikacja i ochrona mieszkań.",
  "help.faq.title": "Często zadawane pytania",
  "help.contact.cta": "Nie znalazłeś odpowiedzi?",
  "help.contact.button": "Skontaktuj się z nami",
  "careers.hero.badge": "Dołącz do zespołu",
  "careers.hero.title": "Budujmy przyszłość podróży",
  "careers.hero.subtitle":
    "Poszukujemy ludzi z pasją, którzy na nowo zdefiniują sposób, w jaki goście podróżują po Europie.",
  "careers.values.title": "Nasze wartości",
  "careers.values.trust.title": "Człowiek i zaufanie",
  "careers.values.remote.title": "Elastyczna telepraca",
  "careers.values.impact.title": "Prawdziwy wpływ",
  "careers.openings.title": "Otwarte pozycje",
  "careers.openings.empty":
    "Aktualnie brak wolnych stanowisk. Nie wahaj się i wyślij spontaniczną aplikację!",
  "careers.apply.title": "Spontaniczna aplikacja",
  "careers.apply.desc":
    "Wyślij swoje CV i powiedz nam, jak możesz pomóc Donkey Travel.",
  "careers.apply.button": "Wyślij moją aplikację",
  "contact.hero.badge": "Kontakt",
  "contact.hero.title": "Jesteśmy tu dla Ciebie",
  "contact.hero.subtitle":
    "Pytanie, sugestia lub problem? Nasz zespół jest gotowy Cię wysłuchać.",
  "contact.form.name": "Twoje imię",
  "contact.form.email": "Twój e-mail",
  "contact.form.subject": "Temat Twojej wiadomości",
  "contact.form.message": "Twoja wiadomość...",
  "contact.form.send": "Wyślij wiadomość",
  "contact.info.title": "Przydatne informacje",
  "contact.info.email": "kontakt@donkey.travel",
  "contact.info.address": "Dolina Haute-Somme, Pikardia, Francja",
  "contact.info.hours": "Pon. - Pt.: 9:00 - 18:00",
  activez_votre_abonnement: "Aktywuj swoją subskrypcję",
  finalisez_votre_inscription: "Dokończ rejestrację",
  _changes_illimit_s_en_europe: "Nielimitowane wymiany w Europie",
  validit___1_an: "Ważność: 1 rok",
  paiement_100__s_curis__par_paypal: "100% bezpieczna płatność przez PayPal",
  me_d_connecter_et_revenir_plus_tard: "Wyloguj się i wróć później",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Błąd podczas sprawdzania płatności na naszych serwerach.",
  le_paiement_n_a_pas_pu__tre_valid_: "Nie udało się potwierdzić płatności.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Podczas płatności wystąpił nieznany błąd.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Nie można zainicjować systemu PayPal. Sprawdź swoje połączenie.",
  donn_es_personnelles: "Dane osobowe",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Dołącz do naszej społeczności i zarezerwuj zakwaterowanie w {{city}}, korzystając z jasnych, stałych opłat i ubezpieczenia.",
  bienvenue: "Powitanie",
  code_promo_applique_avec_succes: "Kod promocyjny został pomyślnie użyty!",
  cible: "Cel",
  propose: "Zaproponować",
  "1_sens": "1 zmysł",
  "2_sens": "2 zmysły",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Chcą odwiedzić Twoją okolicę.<br />To od Ciebie zależy, gdzie mieszkają!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Szukają Cię ORAZ<br />mieszkają tam, gdzie chcesz!",
  comment_ca_marche: "Jak to działa?",
  comprendre_les_differents_types_de_matching:
    "Zrozumienie różnych typów dopasowywania",
  match_reciproque: "Wzajemne dopasowanie",
  details_de_la_demande: "Zapytaj o szczegóły",
  souhaite_venir_dans_votre_secteur: "Chciałbym przyjechać do Twojej okolicy:",
  peut_vous_accueillir: "Może pomieścić Cię:",
  souhaite_visiter_dans_un_rayon:
    "Chciałbym odwiedzić <strong>{{city}}</strong> w promieniu <strong>{{radius}} km</strong>, Twoje zakwaterowanie odpowiada wyszukiwaniu.",
  souhaite_visiter_ville:
    "Chciałbym odwiedzić <strong>{{city}}</strong>, Twoje zakwaterowanie odpowiada wyszukiwaniu.",
  a_besoin_de_chambres: "Potrzebuje {{count}} pokoi.",
  comparateur_de_valeur: "Porównanie wartości",
  ecart: "luka",
  code_promo_invalide: "Nieprawidłowy kod promocyjny",
  erreur_verification_code: "Błąd weryfikacji kodu",
  vous_avez_un_code_promo: "Czy masz kod promocyjny?",
  entrez_votre_code: "WPROWADŹ SWÓJ KOD",
  appliquer: "Zastosuj",
  importation_r_ussie_: "Import udany! Twoje dane zostały wstępnie wypełnione.",
  erreur_lors_de_l_importation: "Błąd podczas importu:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Opisz, co czyni Twój dom wyjątkowym...",
  mettez_en_avant_les_points_forts___votre:
    "Podkreśl mocne strony swojego zakwaterowania",
  lien_annonce_airbnb_1: "Link do Twojej oferty Airbnb",
  importation___: "Import...",
  importer_l_annonce: "Importuj reklamę",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Wpisz link do swojego ogłoszenia. Możesz automatycznie importować szczegóły, aby zaoszczędzić czas.",
  lien_calendrier_airbnb: "Link do kalendarza (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Użyjemy tego linku, aby zsynchronizować Twoją dostępność.",
  entrer_en_contact: "Skontaktuj się",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Uwaga: wysokie ryzyko uzależnienia od bezpłatnych przejazdów!",
};
